import { without } from 'es-toolkit';
import React, { useMemo } from 'react';

import { formatLumberSpecies, formatLumberSpeciesLong, LUMBER_SPECIES, LumberSpecies } from '@paragon/contract-library';
import { naturalSort } from '@paragon/utilities';

import { getAllowedGradesBySpecies } from '../../../../selectors/lumberOptionGroupSelectors';
import { useAppSelector } from '../../../hooks';
import { LumberPropertySelectDialog } from './LumberPropertySelectDialog';
import { LumberSelectProps } from './LumberSelectProps';

const SORTED_SPECIES = without(LUMBER_SPECIES, 'Combo', 'Unknown').toSorted(naturalSort);

export function LumberSpeciesSelect(props: LumberSelectProps<LumberSpecies>) {
  const allowedGradesBySpecies = useAppSelector(getAllowedGradesBySpecies);

  const speciesOptions = useMemo(
    () => SORTED_SPECIES.filter((species) => allowedGradesBySpecies && allowedGradesBySpecies[species]),
    [allowedGradesBySpecies],
  );

  return (
    <LumberPropertySelectDialog
      type="species"
      values={speciesOptions}
      selectedValues={props.value}
      onSelectedValuesChange={props.onChange}
      formatSingleValue={(value) => formatLumberSpeciesLong(value, [])}
      // This control is not used to represent combo species, so we can safely pass [] as tangible species
      formatMultipleValues={(values) =>
        values
          .map((value) => (values.length > 3 ? formatLumberSpecies(value, []) : formatLumberSpeciesLong(value, [])))
          .toSorted(naturalSort)
          .join(', ')
      }
    />
  );
}
